import { getBaseUrl } from "./api";

const getFileUrl = (image) => {
  return `${getBaseUrl()}${image}`;
};

export default getFileUrl;
